import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SectionsChangesEvent } from './classes/sections-changes-event';
import { SortBtnsEvent } from './classes/sort-btns-event';
import { TagsChangesEvent } from './classes/tags-changes-event';

@Injectable({
  providedIn: 'root'
})
export class EventPoolService {

  constructor() { }

  sectionsListener$ : Subject<SectionsChangesEvent> = new Subject<SectionsChangesEvent>();
  sortBtnsListener$ : Subject<SortBtnsEvent> = new Subject<SortBtnsEvent>();
  tagsListener$ : Subject<TagsChangesEvent> = new Subject<TagsChangesEvent>();

  update(event : SortBtnsEvent)
  update(event : SectionsChangesEvent)
  update(event : TagsChangesEvent)
  update(event : any){
    if(event instanceof SectionsChangesEvent) this.sectionsListener$.next(event);
    if(event instanceof SortBtnsEvent) this.sortBtnsListener$.next(event);
    if(event instanceof TagsChangesEvent) this.tagsListener$.next(event);
  }
  
}
